// src/pages/Main/frontCode.js

import React from "react";
import { Card } from "react-bootstrap";
import "pages/Main/frontCode.css";

// A code card's source marks each highlighted run as `{class|text}`; everything else is plain text.
export const POLICY = `{p|- }{e|alias}: {s|read_only}
  {e|default}: {s|allow}
  {e|rules}:
  - {e|id}: {n|no_writes}
    {e|effect}: write
    {e|action}: {k|deny}
{p|- }{e|alias}: {s|standard}
  {e|rules}:
  - {e|id}: {n|publish}
    {e|effect}: exec
    {e|command}: [{s|"git push*"}]
    {e|action}: {k|ask}`;

export const TERMINAL = `{p|$ }{e|blobhub} workflow deploy {n|-f} {s|manifest.yaml}
{o|deployed}   workflow/daily_session
{o|deployed}   workflow/tick
{c|unchanged}  desk
{p|$ }{e|blobhub} scheduler deploy {n|-f} {s|schedules.yaml}
{o|created}    market-open
{k|updated}    market-close {c|(cron)}
{p|$ }{e|blobhub} workflow execute {n|-f} {s|manifest.yaml} \\
    {n|--definition} {s|daily_session} {n|--session} {s|2026-10-13}
{c|execution} {n|7ee63e6e…} {c|on session} {n|558fcefa…}: {o|completed}`;

export const PYTHON = `{k|import} blobhub
{k|from} blobhub.types.workflow {k|import} Workflow

hub = blobhub.connect()
rev = hub.blob({s|"dragon-nest"}, {s|"dragon-pulse-dev"}).revision()
run = Workflow(rev).execute({s|"daily_session"}, session={s|"2026-10-13"})

status = run.wait(on_event=print)  {c|# "completed", "failed" or "stopped"}
{k|for} event {k|in} run.events():         {c|# the whole record, oldest first}
    print(event[{s|"type"}], event.get({s|"message"}))`;

/** The source as text and highlighted spans, ready to sit inside a `<pre>`. */
export const highlight = (source) => source.split(/(\{[a-z]\|[^}]*\})/).map((part, i) => {
  const run = /^\{([a-z])\|([^}]*)\}$/.exec(part);
  return run ? <span key={i} className={`fp-hl-${run[1]}`}>{run[2]}</span> : part;
});

/** A highlighted snippet; with a `title` it wears the eyebrow strip, naming its file on the right. */
export const CodeCard = ({ title, file, source }) => (
  <Card className="fp-code-card">
    {title && (
      <Card.Header className="fp-card-header">
        {title}
        <code className="fp-code-file">{file}</code>
      </Card.Header>
    )}
    <pre className="fp-code">{highlight(source)}</pre>
  </Card>
);
